import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = () => ({
  exportCsv: {
    loading: false,
    error: false,
  },
});

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
